import React from 'react'
import {openSidePanelSelecting, openSidePanelSelectingMultiple, openSidePanel} from "../sidePanel/sidePanel-action";
import Types from "../sidePanel/sidePanel-types";
import Text from "../../label";


const sampleTest = component => () => <Text>{component}</Text>

export const open = (panelId, component) => (
    openSidePanel(panelId, component || sampleTest('app.sidePanel.open'), {}, Types.slideRight + ' sidePanel-sample', 'app.sidePanel.open')
)

export const select = (panelId) => (
    openSidePanelSelecting(panelId, sampleTest('app.sidePanel.select'), {}, Types.slideRight + ' sidePanel-sample', 'app.sidePanel.select')
)

export const selects = (panelId) => (
    openSidePanelSelectingMultiple(panelId, sampleTest('app.sidePanel.selects'), {}, Types.slideRight + ' sidePanel-sample', 'app.sidePanel.selects')
)
